import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg, tokens } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHead, Panel, SButton, sInput, sLabel } from "@/components/staff/Bits";

export default function ChangePassword() {
  const { user, refreshMe } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const set = (p) => setF((o) => ({ ...o, ...p }));
  const submit = async () => {
    if (f.new_password.length < 10) { toast.error("Use at least 10 characters."); return; }
    if (f.new_password !== f.confirm) { toast.error("Passwords do not match."); return; }
    try { const { data } = await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password }); tokens.set(data.access_token, data.refresh_token); toast.success("Password changed"); await refreshMe(); nav("/office"); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="max-w-md">
      <PageHead title="Change password" sub={user.must_change_password ? "Please set your own password before continuing." : "Use a long passphrase that you do not use elsewhere."} />
      <Panel testid="change-password-panel">
        <div className="space-y-3">
          <div><label className={sLabel} htmlFor="cp">Current password</label><input id="cp" type="password" data-testid="current-password-input" className={sInput} value={f.current_password} onChange={(e) => set({ current_password: e.target.value })} /></div>
          <div><label className={sLabel} htmlFor="np">New password (10+ characters)</label><input id="np" type="password" data-testid="new-password-input" className={sInput} value={f.new_password} onChange={(e) => set({ new_password: e.target.value })} /></div>
          <div><label className={sLabel} htmlFor="cf">Confirm new password</label><input id="cf" type="password" data-testid="confirm-password-input" className={sInput} value={f.confirm} onChange={(e) => set({ confirm: e.target.value })} /></div>
          <SButton data-testid="change-password-submit" onClick={submit}>Save password</SButton>
        </div>
      </Panel>
    </div>
  );
}
